//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HouseItem from '@/components/business/house_item'
export default {
    props: {
        buildings: Array
    },
    data () {
        return {
            current: 0

        }
    },
    components: {
        HouseItem
    },
    computed: {
        getHeight() {
            return (item) => {
                let height = 230
                if (item && item.price_desc_arr && item.price_desc_arr.length > 1) {
                    height += item.price_desc_arr.length * 30
                }
                return (height + 128) + 'px'                
            }
        },
         paginations () {
            return this.buildings.map((item, i) => i)
        },
        tabs () {
            if (!this.buildings.length) {
                return []
            }
            const current_house = this.buildings[this.current]
            const { name, vr_panorama_resource, vr_resource, building_id, activities } = current_house
            return [
                {
                    name: '航拍看房',
                    icon: 'web-720',
                    show: vr_panorama_resource && vr_panorama_resource.vr_panorama_url,
                    link: `/building/web_720?building_id=${building_id || ''}&title=${name}&link=${encodeURIComponent(vr_panorama_resource && vr_panorama_resource.vr_panorama_url)}`
                },
                {
                    name: 'VR看房',
                    icon: 'vr',
                    show: vr_resource && vr_resource.vr_photo_url,
                    link: `/building/vr?building_id=${building_id}&title=${name}`
                },
                {
                    name: '楼盘总平',
                    icon: 'planar',
                    show: activities && activities.indexOf('planar_graph') > -1,
                    link: `/building/planar_graph?building_id=${building_id}`
                },
                {
                    name: '日照模拟',
                    icon: 'sunlight',
                    show: activities && activities.indexOf('sunlight') > -1,
                    link: `/building/sunlight?building_id=${building_id}&title=${name}`
                },
                {
                    name: '户型图',
                    icon: 'layout',
                    show: current_house.layout_image_exists,
                    link: `/building/img_preview?type=layout&title=${name}&building_id=${building_id}`
                },
                {
                    name: '周边配套',
                    icon: 'map',
                    show: current_house.around_facility_exists,
                    link: `/building/around_facilities/map?id=${building_id}&location=${current_house.location}&name=${name}&category=`
                },
                {
                    name: '楼盘动态',
                    icon: 'event',
                    show: true,
                    link: `/building/event?building_id=${building_id}&from=置业顾问名片页`
                },
                {
                    name: '楼盘图片',
                    icon: 'pic',
                    show: current_house.common_image_exists,
                    link: `/building/img_prediv?type=common&title=${name}&building_id=${building_id}`
                },
                {
                    name: '楼盘详情',
                    icon: 'info',
                    show: true,
                    link: `/building/info?type=common&title=${name}&building_id=${building_id}`
                }
            ].filter(v => v.show).slice(0, 5)
        }
    },
    methods: {
        openLink (url) {
            wx.navigateTo({
                url
            })
        },
        changeSwiper ({ detail }) {
            this.current = detail.current
        }
    }
}
